import { c as _c } from "react/compiler-runtime";
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { GroupsControllerCreateGroupMutationRequest, GroupsControllerCreateGroupMutationResponse, GroupsControllerCreateGroupPathParams, GroupsControllerCreateGroup400, GroupsControllerCreateGroup401, GroupsControllerCreateGroup403, GroupsControllerCreateGroup404 } from "../../models/documentGroupsController/GroupsControllerCreateGroup";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { groupsControllerCreateGroup } from "../../clients/document-groupsService/groupsControllerCreateGroup";
import { mutationOptions, useMutation } from "@tanstack/react-query";
export const groupsControllerCreateGroupMutationKey = () => [{
  url: '/api/v1/documents/groups/projects/:projectId'
}] as const;
export type GroupsControllerCreateGroupMutationKey = ReturnType<typeof groupsControllerCreateGroupMutationKey>;
export function groupsControllerCreateGroupMutationOptions<TContext = unknown>(config: Partial<RequestConfig<GroupsControllerCreateGroupMutationRequest>> & {
  client?: typeof fetch;
} = {}) {
  const mutationKey = groupsControllerCreateGroupMutationKey();
  return mutationOptions<GroupsControllerCreateGroupMutationResponse, ResponseErrorConfig<GroupsControllerCreateGroup400 | GroupsControllerCreateGroup401 | GroupsControllerCreateGroup403 | GroupsControllerCreateGroup404>, {
    projectId: GroupsControllerCreateGroupPathParams["projectId"];
    data?: GroupsControllerCreateGroupMutationRequest;
  }, TContext>({
    mutationKey,
    mutationFn: async ({
      projectId,
      data
    }) => {
      return groupsControllerCreateGroup(projectId, data, config);
    }
  });
}

/**
 * @description Creates a typed group whose members are written with reason BY_USER. Every member must be a live document in the project. CONTRACT_SET: exactly one PRIMARY member (the prime contract); other members may carry ATTACHMENT, REFERENCE or SUPPORTING. DISCREPANCY_SET: exactly two members, no roles, no ranks (a warning surface). ORDER_OF_PRECEDENCE: at least two members, optional ranks (lower governs, ties allowed). Ranks on any other type are rejected. Members are `document-group-members` resources (rank, role, reason, status, citations with resolved source/target annotations) and sideload via `include=members`; their documents sideload via `include=members.document`. Members of VERSIONED or DELETED documents are omitted. When the group changes the project's effective orders, relationship re-inference is notified.
 * @summary Create a document group in a project
 * {@link /api/v1/documents/groups/projects/:projectId}
 */
export function useGroupsControllerCreateGroup(t0) {
  const $ = _c(19);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  let t2;
  if ($[2] !== options) {
    t2 = options ?? {};
    $[2] = options;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    mutation: t3,
    client: t4
  } = t2;
  let t5;
  if ($[4] !== t3) {
    t5 = t3 === undefined ? {} : t3;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const mutation = t5;
  let t6;
  if ($[6] !== t4) {
    t6 = t4 === undefined ? {} : t4;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const config = t6;
  let mutationOptions;
  let queryClient;
  if ($[8] !== mutation) {
    ({
      client: queryClient,
      ...mutationOptions
    } = mutation);
    $[8] = mutation;
    $[9] = mutationOptions;
    $[10] = queryClient;
  } else {
    mutationOptions = $[9];
    queryClient = $[10];
  }
  let t7;
  if ($[11] !== mutationOptions.mutationKey) {
    t7 = mutationOptions.mutationKey ?? groupsControllerCreateGroupMutationKey();
    $[11] = mutationOptions.mutationKey;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const mutationKey = t7;
  let t8;
  if ($[13] !== config) {
    t8 = groupsControllerCreateGroupMutationOptions(config);
    $[13] = config;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const baseOptions = t8 as UseMutationOptions<GroupsControllerCreateGroupMutationResponse, ResponseErrorConfig<GroupsControllerCreateGroup400 | GroupsControllerCreateGroup401 | GroupsControllerCreateGroup403 | GroupsControllerCreateGroup404>, {
    projectId: GroupsControllerCreateGroupPathParams["projectId"];
    data?: GroupsControllerCreateGroupMutationRequest;
  }, TContext>;
  let t9;
  if ($[15] !== baseOptions || $[16] !== mutationKey || $[17] !== mutationOptions) {
    t9 = {
      ...baseOptions,
      mutationKey,
      ...mutationOptions
    };
    $[15] = baseOptions;
    $[16] = mutationKey;
    $[17] = mutationOptions;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return useMutation(t9, queryClient) as UseMutationResult<GroupsControllerCreateGroupMutationResponse, ResponseErrorConfig<GroupsControllerCreateGroup400 | GroupsControllerCreateGroup401 | GroupsControllerCreateGroup403 | GroupsControllerCreateGroup404>, {
    projectId: GroupsControllerCreateGroupPathParams["projectId"];
    data?: GroupsControllerCreateGroupMutationRequest;
  }, TContext>;
}